import React, { Component } from 'react';
import styled from 'styled-components';

import ContactsBlock from '../../components/Contacts';
import Form from '../FormContainer';
import Content from '../Content';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import anchorScroll from '../../utils/anchorScroll';
import { getDirectionCheckboxes } from '../../utils/directionsData';

class ContactsFormBlock extends Component {
    constructor() {
        super();
        this.scrollTo = this.scrollTo.bind(this);
    }

    scrollTo() {
        const { scrollRef } = this.props;
        anchorScroll(scrollRef);
    }

    render() {
        const {
            className,
            page,
            reverse,
            extractCheckboxes = getDirectionCheckboxes,
            // isWhiteBgColorForm = false,
            scrollRef,
        } = this.props;

        return (
            <Root className={className} ref={scrollRef}>
                <Ref>
                    <Wrapper
                        reverse={reverse}
                    >
                        <FormStyled
                            checkboxes={extractCheckboxes()}
                            reverse={reverse}
                            scrollTo={this.scrollTo}
                        />
                        <ContactsBlockStyled
                            page={page}
                            reverse={reverse}
                        />
                    </Wrapper>
                </Ref>
            </Root>
        );
    }
}

const Ref = styled.div``;

const Root = styled.div``;

const Wrapper = styled(Content)`
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${mediaWidth.m} {
        flex-direction: row;

        align-items: baseline;
    }
`;

const FormStyled = styled(Form)`
    ${mediaWidth.m} {
        min-width: 261px;
        width: 261px;

        margin-right: 91px;
    }

    ${mediaWidth.l} {
        min-width: 359px;
        width: 359px;

        margin-right: 101px;
    }

    ${mediaWidth.xl} {
        min-width: 405px;
        width: 405px;

        margin-right: 361px;
    }
`;

const ContactsBlockStyled = styled(ContactsBlock)`
        margin-top: ${({ reverse }) => (reverse ? '0px' : '64px')};

        ${mediaWidth.m} {
            margin-top: 0px;
    }
`;

export default ContactsFormBlock;
